import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import {fetchReservationIfNeeded} from '@/actions/reservation';
import {setCheckoutOverlay} from '@/actions/ui';
import ContinueCheckoutBanner from '../components/ContinueCheckoutBanner';
import { navigate } from '../../checkout/helpers/navigationService';
import ContainerProps from './ContinueCheckoutBannerContainerComponent';
import { secondsTohhmmss } from '../../helpers/time';
import { getNumItemsInCart } from 'checkout/selectors/cart';
import { hasAppliedReserveCoupon } from 'checkout/selectors/reserved-seating';
import { showContinueCheckoutBanner, getEmbedCartBehavior } from 'checkout/selectors/ui';
import { EMBED_CART_BEHAVIOR_PIN_TO_BOTTOM } from '../../checkout/reducers/ui';
import { isListingCheckoutLoginEnabled } from '@b/checkout/selectors/settings';
import { isDynamicListing } from '@b/checkout/selectors/dynamic-listing';
import { reservationActive } from '@b/checkout/selectors/reservation';

class ContinueCheckoutBannerContainer extends Component<ContainerProps> {
    getTime = () => {
        return(secondsTohhmmss(this.props.timeRemaining));
    }

    componentDidMount = () => {
        try {
            if(localStorage && JSON.parse(localStorage.getItem("confirmation")) === true) {
                return;
            }
        } catch(e) {}

        this.props.fetchReservationIfNeeded().catch(() => {});
    }

    render() {
        if(this.props.isLoginEnabled) {
            return null;
        }

        return(
            <ContinueCheckoutBanner
                showCart={this.onShowCart}
                amount={this.getTotalCost()}
                timeRemaining={this.getTime()}
                itemCount={this.props.itemCount}
                forceShow={this.props.hasAppliedReserveCoupon}
                isDynamicListing={this.props.isDynamic}
                pinToBottom={this.props.pinToBottom}
                showCartPill={this.props.showBanner}
                reservationActive={this.props.active}
            />
        )
    }

    getTotalCost = () => {
        return this.props.totalAmount?.amount + this.props.totalFees;
    };

    onShowCart = () => {
        if (this.props?.token) {
            this.props.setCheckoutOverlay(true);
            navigate(`/cart/${ this.props.token }`)
            window.scrollTo(0,0);
        }
    }
}

const mapStateToProps = state => {
    return {
        active: reservationActive(state),
        token: state.reservation.token,
        totalAmount: state.reservation.total_cost,
        totalFees: state.fees.totalFees,
        itemCount: getNumItemsInCart(state),
        timeRemaining: state.reservation.time_remaining,
        hasAppliedReserveCoupon: hasAppliedReserveCoupon(state),
        showBanner: showContinueCheckoutBanner(state),
        pinToBottom: getEmbedCartBehavior(state) == EMBED_CART_BEHAVIOR_PIN_TO_BOTTOM,
        isLoginEnabled: isListingCheckoutLoginEnabled(state),
        isDynamic: isDynamicListing(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setCheckoutOverlay,
        fetchReservationIfNeeded,
    }, dispatch);
}

ContinueCheckoutBannerContainer.propTypes = {
    token: PropTypes.string.isRequired,
    totalAmount: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(ContinueCheckoutBannerContainer)
